import { Themes } from '@masfront/common-b2c'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = Themes.masmovil

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changeTheme: (state, action: PayloadAction<Themes>) => action.payload,
  },
})

export const { changeTheme } = themeSlice.actions

const themeReducer = themeSlice.reducer
export default themeReducer
